var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Fragment } from 'react';
import { Form as AntdForm } from 'antd';
import { InternalField, connect, InternalVirtualField } from '@formily/react-schema-renderer';
import { MegaLayoutItem } from './FormMegaLayout/index';
import { normalizeCol, pickFormItemProps, pickNotFormItemProps, log } from '../shared';
import { useDeepFormItem } from '../context';
var AntdFormItem = AntdForm.Item;
var computeStatus = function (props) {
    if (props.loading) {
        return 'validating';
    }
    if (props.invalid) {
        return 'error';
    }
    if (props.warnings && props.warnings.length) {
        return 'warning';
    }
    if (props.active) {
        return 'success';
    }
    return '';
};
var computeMessage = function (errors, warnings) {
    var messages = [].concat(errors || [], warnings || []);
    return messages.length
        ? messages.map(function (message, index) {
            return React.createElement('span', { key: index }, message, messages.length - 1 > index ? ' ,' : '');
        })
        : undefined;
};
var ConnectedComponent = Symbol('connected');
export var FormItem = function (topProps) {
    var _a = topProps || {}, name = _a.name, initialValue = _a.initialValue, value = _a.value, visible = _a.visible, display = _a.display, required = _a.required, editable = _a.editable, triggerType = _a.triggerType, unmountRemoveValue = _a.unmountRemoveValue, valueName = _a.valueName, eventName = _a.eventName, getValueFromEvent = _a.getValueFromEvent, rules = _a.rules, children = _a.children, component = _a.component, props = _a.props, itemProps = __rest(_a, ["name", "initialValue", "value", "visible", "display", "required", "editable", "triggerType", "unmountRemoveValue", "valueName", "eventName", "getValueFromEvent", "rules", "children", "component", "props"]);
    var topFormItemProps = useDeepFormItem();
    var renderComponent = function (_a) {
        var _b;
        var props = _a.props, state = _a.state, mutators = _a.mutators, form = _a.form;
        if (!component) {
            if (children)
                return React.createElement(Fragment, null, children);
            log.error("Can't fount the component. Its key is " + name + ".");
            return null;
        }
        if (!component['__ALREADY_CONNECTED__']) {
            component[ConnectedComponent] =
                component[ConnectedComponent] ||
                    connect({
                        eventName: eventName,
                        valueName: valueName,
                        getValueFromEvent: getValueFromEvent
                    })(component);
        }
        return React.createElement(component['__ALREADY_CONNECTED__']
            ? component
            : component[ConnectedComponent], __assign(__assign({}, state), { props: (_b = {},
                _b['x-component-props'] = props,
                _b), form: form,
            mutators: mutators }), children);
    };
    var renderField = function (fieldProps) {
        var form = fieldProps.form, state = fieldProps.state, mutators = fieldProps.mutators;
        var props = state.props, errors = state.errors, warnings = state.warnings, editable = state.editable, required = state.required;
        var labelCol = props.labelCol, wrapperCol = props.wrapperCol, help = props.help;
        var formItemProps = pickFormItemProps(props);
        var _a = pickNotFormItemProps(props), inline = _a.inline, componentProps = __rest(_a, ["inline"]);
        var size = topFormItemProps.size;
        var itemProps = __assign(__assign({}, formItemProps), { required: editable === false ? undefined : required, labelCol: formItemProps.label ? normalizeCol(labelCol) : {}, wrapperCol: formItemProps.label ? normalizeCol(wrapperCol) : {}, validateStatus: computeStatus(state), help: computeMessage(errors, warnings) || help });
        return React.createElement(MegaLayoutItem, __assign({ itemProps: __assign(__assign({}, itemProps), { size: size }) }, props), function (megaComponentProps) {
            if (megaComponentProps) {
                return renderComponent({ props: megaComponentProps, state: state, mutators: mutators, form: form });
            }
            return (React.createElement(AntdFormItem, __assign({}, itemProps), renderComponent({ props: componentProps, state: state, mutators: mutators, form: form })));
        });
    };
    if (!component && children) {
        return (React.createElement(InternalVirtualField, { name: name, visible: visible, display: display, props: __assign(__assign(__assign({}, topFormItemProps), itemProps), props) }, renderField));
    }
    return (React.createElement(InternalField, { name: name, initialValue: initialValue, unmountRemoveValue: unmountRemoveValue, value: value, visible: visible, display: display, required: required, rules: rules, editable: editable, triggerType: triggerType, props: __assign(__assign(__assign({}, topFormItemProps), itemProps), props) }, renderField));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/antd/esm/components/FormItem.js
// module id = 4693
// module chunks = 0